import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { SetMotd } from '../../authentication/model/motd.model';
import { Store } from '@ngrx/store';
import { selectMotd } from '../../authentication/store/user.selector';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { extendTextArea } from 'src/app/shared/style';
import { Subscription } from 'rxjs';
import { getMotd, updateMotd } from '../../authentication/store/motd.action';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'sibat-motd-edit-dialog',
  template: `
    <ng-container *transloco="let t; read: 'cockpit'">
      <h2 mat-dialog-title>{{ t('welcomeMessage') }}</h2>

      <mat-dialog-content class="motd-content">
        <form [formGroup]="defectForm" class="motd-edit">
          <label>{{ t('welcomeMessageDe') }}</label>
          <textarea matInput rows="10" formControlName="messageDe"> </textarea>

          <label>{{ t('welcomeMessageFr') }}</label>
          <textarea matInput rows="10" formControlName="messageFr"> </textarea>
        </form>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button (click)="close()">
          {{ t('cancel') }}
        </button>

        <button mat-raised-button color="primary" (click)="validateMotd()">
          {{ t('submit') }}
        </button>
      </mat-dialog-actions>
    </ng-container>
  `,
  styleUrls: ['./motd-edit-dialog.component.scss'],
  imports: [
    TranslocoDirective,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    ReactiveFormsModule,
    MatInput,
    MatDialogActions,
    MatButton,
  ],
})
export class MotdEditDialogComponent implements OnInit, OnDestroy {
  motd$ = this.store.select(selectMotd);
  motdSubscription = new Subscription();
  readonly messageDe = this.formBuilder.control(undefined);
  readonly messageFr = this.formBuilder.control(undefined);
  readonly defectForm = this.formBuilder.group(
    {
      messageDe: this.messageDe,
      messageFr: this.messageFr,
    },
    { validators: Validators.required }
  );

  constructor(
    public store: Store,
    public formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<MotdEditDialogComponent, SetMotd>
  ) {}

  ngOnInit(): void {
    this.motdSubscription.add(
      this.motd$.subscribe(motd => {
        this.messageDe.setValue(motd?.messageDe);
        this.messageFr.setValue(motd?.messageFr);
      })
    );
    this.store.dispatch(getMotd());
  }

  ngOnDestroy() {
    this.motdSubscription.unsubscribe();
  }

  validateMotd(): void {
    const motd: SetMotd = {
      messageDe: this.messageDe.value,
      messageFr: this.messageFr.value,
    };
    this.store.dispatch(updateMotd({ motd }));
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  extendTextArea(element) {
    extendTextArea(element);
  }
}
